//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class WebhookLogDisplayItem extends ItemBase {
    ID: string | null = null;
    WebhookID: string | null = null;
    Url: string | null = null;
    RequestBody: string | null = null;
    ResponseBody: string | null = null;
    CreatedDate: string = "1970-01-01T00:00:00";
    LastAttempt: string | null = null;
    NextAttempt: string | null = null;
    LastStatusCode: number | null = null;
    Attempts: number = 0;
    ResponseDuration: number = 0;
    IPAddress: string | null = null;
    LiveMode: boolean = false;
    EventType: string | null = null;

    constructor(initializer?: Partial<WebhookLogDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "WebhookLogDisplayItem";
}
